import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from 'src/app/services/http/http.service';
import { User } from '../models/User';
import { HeaderType } from "@dealpos-npm/ng-dealpos-library/header-type";

@Component({
    selector: 'app-my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.scss'],
    standalone: false
})
export class MyProfileComponent implements OnInit {
  user: User;
  newPassword: string;
  rePassword: string;

  constructor(private httpService: HttpService, private toastr: ToastrService) {
    this.user = new User();
  }

  ngOnInit() {
    this.httpService.post<User>("/API/Profile/Getinfo", {})
    .subscribe((userInfo: User) => {
      this.user = userInfo;
    })
  }

  public onSave() {
    if (!this.validateSave()) {
      return;
    }

    this.user.RePassword = this.rePassword;
    this.user.NewPassword = this.newPassword;
    this.httpService.post<{Message: string}>("/API/Profile/SubmitForm", this.user)
    .subscribe((response: {Message: string}) => {
      this.toastr.success(response.Message, HeaderType.Success);
    })
  }

  private validateSave() {
    if (this.rePassword != this.newPassword) {
      this.toastr.error("Password and re-enter password must be equal.", HeaderType.Error);
      return false;
    }
    return true;
  }
}
